<script>
    import router from "page";

    import Dropdown from "../components/Dropdown.svelte";

    import {
        isAuthenticated,
        isAdmin,
        activePage,
        client,
        locale,
        user,
    } from "../stores.js";

    let showMenu;
    function toggleMenu() {
        showMenu = !showMenu;
    }

    function logout() {
        localStorage.removeItem("token");
        $isAuthenticated = false;
        router("/login");
    }
</script>

<Dropdown
    options={{
        hover: true,
        dropdownStyle: "max-width: 200px; right: 10px;",
    }}
>
    <i
        slot="toggle"
        class="menu-toggle fas fa-user-circle"
        on:click={toggleMenu}
    />

    <a href="/user">
        <div class="menu-item" class:active={$activePage == "user"}>
            {$client.companyKey} - {$client.companyName}
        </div>
    </a>

    <hr />

    <a href="/brands">
        <div class="menu-item">{$locale.brands || ""}</div>
    </a>

    <a href="/products?view=pricelist">
        <div class="menu-item">{$locale.pricelist || ""}</div>
    </a>

    <a href="/orders">
        <div class="menu-item">{$locale.orders || ""}</div>
    </a>

    <a href="/invoices">
        <div class="menu-item">{$locale.invoices || ""}</div>
    </a>

    <!-- <hr />

    <a href="/invoices">
        <div class="menu-item">Поплаки</div>
    </a> -->

    <hr />

    <div on:click={logout} class="menu-item logout" class:right={$isAdmin}>
        <i class="fas fa-power-off" />
        {$locale.logout || ""}
    </div>
</Dropdown>

<style>
    .menu-toggle {
        font-size: 30px;
        color: #999;
        cursor: pointer;
    }

    .menu-item {
        border-radius: 3px;
        color: black;
        display: flex;
        align-items: center;
    }

    .menu-item i {
        margin-right: 10px;
        width: 20px;
        opacity: 0.3;
        text-align: center;
    }

    hr {
        border: 0;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
    }

    .logout {
        color: red;
        cursor: pointer;
    }
</style>
